import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import * as LogRocket from 'logrocket';
import { environment } from '../../environments/environment';

@Injectable()
export class LogRocketInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!environment.logRocket?.enabled) {
      return next.handle(req);
    }

    return next.handle(req).pipe(
      tap(
        event => {
          if (event instanceof HttpResponse && event.status >= 400) {
            LogRocket.log(`API ${event.status}: ${req.method} ${req.url}`);
          }
        },
        error => {
          // status === 0 means the browser never received a response (request
          // cancelled by navigation, network drop, CORS/ad-blocker). These are not
          // real backend errors, so don't report them to LogRocket — they're noise.
          if (error instanceof HttpErrorResponse && error.status !== 0) {
            LogRocket.captureException(error);
            LogRocket.log(`API Error: ${req.method} ${req.url}`, {
              errorMessage: error.message,
              status: error.status,
            });
          }
        }
      )
    );
  }
}